import { createContext } from 'react';
import { IWatchNotificationsData, IDataGetWatchInfo } from 'types';

export type TTypeOfModalWindow = null | 'success' | 'error' | 'confirm';
export interface IDataForPushArgs {
	serialNumber: string;
	data: IWatchNotificationsData;
}

export interface IWatchFullInfoState {
	watchFullInfo: Nullable<IDataGetWatchInfo>;
	dataForPush: Nullable<IDataForPushArgs>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const watchFullInfoInitialState: IWatchFullInfoState = {
	watchFullInfo: null,
	dataForPush: null,
	typeOfModalWindow: null,
};

export interface IWatchFullInfoContext extends IWatchFullInfoState {
	setDataForPush(dataForPush: Nullable<IDataForPushArgs>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const WatchFullInfoContext = createContext<IWatchFullInfoContext>({
	setDataForPush: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...watchFullInfoInitialState,
});
